import React, {useEffect, useState} from 'react';
import {IonContent, IonModal, IonPage} from '@ionic/react';
import {useHistory} from 'react-router-dom';
import {ApiService} from "../api/ApiService";
import {toastStore} from "../components/AppToast";
import LoadDetailHeader, {useTransparentHeaderContrast} from '../components/LoadDetailHeader';

const NewTrainee: React.FC = () => {
    const history = useHistory();
    const {onSheet, onIonScroll} = useTransparentHeaderContrast();
    const [mounted, setMounted] = useState(false);

    const [traineeCode, setTraineeCode] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const [claiming, setClaiming] = useState(false);

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    const claimTrainee = () => {
        if (claiming) return;
        setClaiming(true);
        ApiService.claimTrainee("newTrainee", {traineeCode: traineeCode.toUpperCase()}).then(() => {
            setShowModal1(false);
            setShowModal(true);
        }).catch(() => {
            toastStore.getState().setToast('This trainee could not be claimed. Please check your connection and try again.');
        }).finally(() => {
            setClaiming(false);
        });
    }

    const handleClaim = () => {
        setTraineeCode(traineeCode.trim())
        if (traineeCode.length > 6) {
            toastStore.getState().setToast('Trainee codes cannot be longer than 6 characters.');
            setShowModal1(false);
        } else {
            claimTrainee();
        }
    }

    const goBack = () => {
      if (history.length > 1) history.goBack();
      else history.replace('/Home');
    };

    return (
        <IonPage>
            <LoadDetailHeader title="New Trainee" onBack={goBack} onSheet={onSheet} />

            <IonContent
              fullscreen
              className="design-a-content design-a-content--light"
              scrollEvents={true}
              onIonScroll={onIonScroll}
            >
              <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                <div className="home-hero advance-hero">
                  <div className="advance-hero__eyebrow">Training</div>
                  <div className="advance-hero__title home-display">New Trainee</div>
                  <div className="advance-hero__meta">Claim a trainee to begin their training</div>
                </div>

                <div className="home-sheet advance-sheet">
                  <div className="advance-card">
                    <div className="advance-card__title">Claim Trainee</div>
                    <p className="advance-card__body">
                      Enter the trainee code provided by your driver manager to assign yourself as
                      their trainer.
                    </p>

                    <label className="profile-field" style={{marginTop: 12}}>
                      <span className="profile-field__label">Trainee Code</span>
                      <input
                        id="trainee"
                        className="profile-field__input"
                        type="text"
                        value={traineeCode}
                        onChange={e => setTraineeCode(e.target.value!)}
                      />
                    </label>

                    <button
                      type="button"
                      className="profile-submit"
                      disabled={traineeCode.trim() === ''}
                      onClick={() => setShowModal1(true)}
                    >
                      Claim
                    </button>
                  </div>
                </div>
              </div>
            </IonContent>

            <IonModal isOpen={showModal1} onDidDismiss={() => setShowModal1(false)}>
              <div className="design-a">
                <div className="roadtest-confirm-modal">
                  <div className="roadtest-confirm-modal__title">Confirm?</div>
                  <p className="roadtest-confirm-modal__body">Assign yourself to trainee: {traineeCode}?</p>
                  <button type="button" className="profile-submit" disabled={claiming} onClick={handleClaim}>Confirm</button>
                  <button type="button" className="roadtest-confirm-modal__secondary" onClick={() => setShowModal1(false)}>Cancel</button>
                </div>
              </div>
            </IonModal>

            <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
              <div className="design-a">
                <div className="roadtest-confirm-modal">
                  <div className="roadtest-confirm-modal__title">Trainee Assigned</div>
                  <p className="roadtest-confirm-modal__body">You have successfully claimed trainee: {traineeCode}.</p>
                  <button
                    type="button"
                    className="profile-submit"
                    onClick={() => { setShowModal(false); history.push('/trainingday'); }}
                  >
                    Done
                  </button>
                </div>
              </div>
            </IonModal>
        </IonPage>
    )
};

export default NewTrainee;
